import request from '@/axios'

export const getMenuListApi = () => {
  console.log('[api/menu/index.ts] getMenuListApi: 开始请求菜单列表 GET /api/v1/menus')
  return request.get({ url: '/api/v1/menus' }).then((res: any) => {
    const list = Array.isArray(res) ? res : res?.data || []
    return { data: list, code: 0, message: '操作成功' }
  })
}

export const createMenuApi = (data: any) => {
  return request.post({ url: '/api/v1/menus', data })
}

export const updateMenuApi = (id: string, data: any) => {
  return request.patch({ url: `/api/v1/menus/${id}`, data })
}

export const deleteMenuApi = (id: string) => {
  return request.delete({ url: `/api/v1/menus/${id}` })
}
